import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PathsEditPage from './pages/paths/EditPage';
import DashboardIndexPage from './pages/dashboard/IndexPage';
import AudienceIndexPage from './pages/audience/IndexPage';
import AudienceProfilePage from './pages/audience/profile/ProfilePage';
import { Provider } from 'react-redux';
import { store } from '../redux/store';
import MessagesIndexPage from "./pages/messages/IndexPage";
import DomainPage from "./pages/users/settings/DomainPage";
import TeamPage from "./pages/users/settings/TeamPage";
import DomainConfigurationPage from './pages/users/settings/components/domain_configuration/DomainConfiguration';
import PathRemindersPage from './pages/paths/RemindersPage';
import ResponsesReportPage from './pages/paths/responses/ResponsesReportPage';
import ChecklistEditPage from './pages/checklists/EditPage';
import DocEditPage from './pages/docs/EditPage';

const AppRoutes = () => {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/:companySlug/audiences" element={<AudienceIndexPage />} />
          <Route path="/:companySlug/audience/:id" element={<AudienceProfilePage />} />
          <Route path="/:companySlug/dashboard" element={<DashboardIndexPage />} />
          <Route path="/:companySlug/messages" element={<MessagesIndexPage />} />
          <Route path="/:companySlug/settings/domain" element={<DomainPage />} />
          <Route path="/:companySlug/settings/domain/:id/domainConfiguration" element={<DomainConfigurationPage />} />
          <Route path="/:companySlug/settings/team" element={<TeamPage />} />
          <Route path="/:companySlug/paths/:lmSlug/edit" element={<PathsEditPage />} />
          <Route path="/:companySlug/paths/:lmSlug/reminders" element={<PathRemindersPage />} />
          <Route path="/:companySlug/paths/:lmSlug/responses" element={<ResponsesReportPage />} />
          <Route path="/:companySlug/checklists/:lmSlug/edit" element={<ChecklistEditPage />} />
          <Route path="/:companySlug/docs/:lmSlug/edit" element={<DocEditPage />} />
        </Routes>
      </Router>
    </Provider>
  );
};


export default AppRoutes;
